const REDIRECT_KEY = 'redirect'

export function consumeRedirectNotice (): boolean {
  try {
    const redirect = localStorage.getItem(REDIRECT_KEY)
    localStorage.removeItem(REDIRECT_KEY)

    return !!redirect
  } catch (e) {
    return false
  }
}
